import mixin from '@/mixins'
import uscMixin from '@/mixins/usc'
import { endAjaxLoading } from '@/util/loading'

export default {
  mixins: [mixin, uscMixin],
  data() {
    return {
      loading: false,
      accountCurrency: null, // for Japanese yen which no decimal point
      accountType: null,
      minLimit: this.$config.depositDefaultAmountMin,
      maxLimit: this.$config.depositDefaultAmountMax,
      depositDiscountProps: {
        depositAmount: 0,
        currency: '',
      },
      discountedAmount: 0, // Deposit Discount
      voucherID: 0, // Deposit Discount
      eligibleForDepositDiscount: false, // Deposit Discount
      accountDetail: {},
    }
  },
  watch: {
    accountCurrency(newValue, oldValue) {
      if (newValue === oldValue) return

      if (this.checkIsUSC(newValue)) {
        this.minLimit = this.convertUSDToUSC(this.minLimit)
        this.rate = this.convertUSCToUSD(this.rate)
      }
      if (!this.checkIsUSC(newValue) && this.checkIsUSC(oldValue)) {
        this.minLimit = this.convertUSCToUSD(this.minLimit)
        this.rate = this.convertUSDToUSC(this.rate)
      }
      this.resetAmount()
    },
  },
  computed: {
    isLoyalty() {
      return (
        this.$store.state.loyalty.loyaltyInfo &&
        this.$store.state.loyalty.loyaltyInfo.status !== 3 &&
        this.eligibleForDepositDiscount
      )
    },
  },
  methods: {
    setCurrency(obj) {
      this.accountCurrency = obj.currency
      this.eligibleForDepositDiscount = obj.eligibleForDepositDiscount

      this[this.formName].amount = this.depositDiscountProps.depositAmount = this.discountedAmount = this.voucherID = 0
    },
    setAccountType(accountType) {
      this.accountType = accountType
    },
    onAmountBlur() {
      this.depositDiscountProps.depositAmount = this[this.formName].amount
      this.depositDiscountProps.currency = this.accountCurrency
    },
    setDepositDiscount(depositDiscount) {
      this.discountedAmount = depositDiscount.payableAmount
      this.voucherID = depositDiscount.voucherID
    },
    depositSubmitWithRate(result, callback) {
      if (result.data.code == 0 && result.data.data) {
        callback(result.data.msg)
      } else if (result.data.code !== 562) {
        this.loading = false
        endAjaxLoading()
        this.errorMessage(this.$t('deposit.default.failed'))
      } else {
        this.loading = false
        endAjaxLoading()
      }
    },
  },
}
